import zonedTimeToUtc from 'date-fns-tz/zonedTimeToUtc'
import addDays from 'date-fns/addDays'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

import { BLOCKING_STATES } from 'components/inspections/constants'

import type { DetectionDateRange } from 'components/exceptions/types'
import type { InspectionStateFilter, InspectionTripFilter } from 'components/inspections/constants'
import type { InspectionListParamsApi } from 'types/api/inspections/inspection'

export const INSPECTIONS_PAGE_SIZE_OPTIONS = [25, 50, 100]
export const DEFAULT_INSPECTIONS_PAGE_SIZE = 25

interface InspectionListFilters {
  search: string
  stateFilter: InspectionStateFilter
  tripFilter: InspectionTripFilter
  dateRange: DetectionDateRange
  timeZone?: string | null
  page: number
  pageSize: number
}

const startOfDayIn = (isoDate: string, timeZone?: string | null): string =>
  (timeZone ? zonedTimeToUtc(`${isoDate}T00:00:00`, timeZone) : new Date(`${isoDate}T00:00:00`)).toISOString()

/**
 * Page filters → list query params. "Out of Service" is both blocking states; "all" sends no narrowing. The date
 * range is whole days in the user's zone, sent as instants with an exclusive end, the way the endpoint compares them.
 */
export const toInspectionListParams = ({
  search,
  stateFilter,
  tripFilter,
  dateRange,
  timeZone,
  page,
  pageSize,
}: InspectionListFilters): InspectionListParamsApi => {
  const params: InspectionListParamsApi = { page, pageSize }
  if (dateRange.startDate) params.from = startOfDayIn(dateRange.startDate, timeZone)
  if (dateRange.endDate) params.to = startOfDayIn(format(addDays(parseISO(dateRange.endDate), 1), 'yyyy-MM-dd'), timeZone)
  if (stateFilter === 'blocking') params.state = BLOCKING_STATES
  else if (stateFilter !== 'all') params.state = [stateFilter]
  if (tripFilter !== 'all') params.tripType = [tripFilter]
  if (search) params.search = search
  return params
}
